import React, { useState } from 'react';

import { SubHeading, MenuItem } from '../../components'
import { data } from '../../constants'
import './FoodMenu.css';

const FoodMenu = () => {
    const menuOptions = ['Lunch', 'Dinner', 'Specials'];
    const [currentMenu, setCurrentMenu] = useState('');
    return (
        <div className='app__foodMenu flex__center section__padding' id='menu'>
            <div className='app__foodMenu-title'>
                <SubHeading title='Menu' />
                <h1 className='headtext__cormorant'>Taste Perfection</h1>
            </div>
            <div className="app__foodMenu-button-group" role="group">
                {menuOptions.map(option => (
                    <button type="button" key={option} className="custom__button" onClick={() => setCurrentMenu(option)}>
                        {option.toLocaleUpperCase()}
                    </button>
                ))}
            </div>
            <div className='app__foodMenu-menu p__opensans'>
                {currentMenu === 'Lunch' && (
                    <div className='app__foodMenu-menu_lunch flex__center'>
                        <p className='app__foodMenu-menu_heading'>Lunch Menu</p>
                        <p className='app__foodMenu-menu_heading_fine-line' />
                        <p className='app__foodMenu-menu_heading'>Appetizers</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.appetizers.map((appetizer, index) => (
                                <MenuItem key={appetizer.title + index} title={appetizer.title} price={appetizer.price} tags={appetizer.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Fresh Salads</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.salads.map((salad, index) => (
                                <MenuItem key={salad.title + index} title={salad.title} price={salad.price} tags={salad.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>From The Grill</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.grills.map((grill, index) => (
                                <MenuItem key={grill.title + index} title={grill.title} price={grill.price} tags={grill.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Other Selections</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.others.map((other, index) => (
                                <MenuItem key={other.title + index} title={other.title} price={other.price} tags={other.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Sandwiches :</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.sandwiches.map((sandwich, index) => (
                                <MenuItem key={sandwich.title + index} title={sandwich.title} price={sandwich.price} tags={sandwich.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Warning</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.warnings.map((warning, index) => (
                                <MenuItem key={warning.title + index} title={warning.title} price={warning.price} tags={warning.tags} />
                            ))}
                        </div>
                    </div>
                )}
                {currentMenu === 'Dinner' && (
                    <div className='app__foodMenu-menu_dinner flex__center'>
                        <p className='app__foodMenu-menu_heading'>Dinner Menu</p>
                        <p className='app__foodMenu-menu_heading_fine-line' />
                        <p className='app__foodMenu-menu_heading'>Appetizers</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.appetizers.map((appetizer, index) => (
                                <MenuItem key={appetizer.title + index} title={appetizer.title} price={appetizer.price} tags={appetizer.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Fresh Salads</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.salads.map((salad, index) => (
                                <MenuItem key={salad.title + index} title={salad.title} price={salad.price} tags={salad.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Entrees</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.entrees.map((entree, index) => (
                                <MenuItem key={entree.title + index} title={entree.title} price={entree.price} tags={entree.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Friday and Saturday Only While it Lasts!</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.fridaySpecials.map((fridaySpecial, index) => (
                                <MenuItem key={fridaySpecial.title + index} title={fridaySpecial.title} price={fridaySpecial.price} tags={fridaySpecial.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Seafood</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.seafoods.map((seafood, index) => (
                                <MenuItem key={seafood.title + index} title={seafood.title} price={seafood.price} tags={seafood.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Pasta</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.pastas.map((pasta, index) => (
                                <MenuItem key={pasta.title + index} title={pasta.title} price={pasta.price} tags={pasta.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Kids or People that are Kids at Heart Meals</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.kidMeals.map((kidMeal, index) => (
                                <MenuItem key={kidMeal.title + index} title={kidMeal.title} price={kidMeal.price} tags={kidMeal.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Beverages</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.beverages.map((beverage, index) => (
                                <MenuItem key={beverage.title + index} title={beverage.title} price={beverage.price} tags={beverage.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Warning</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.warnings.map((warning, index) => (
                                <MenuItem key={warning.title + index} title={warning.title} price={warning.price} tags={warning.tags} />
                            ))}
                        </div>
                    </div>
                )}
                {currentMenu === 'Specials' && (
                    <div className='app__foodMenu-menu_specials flex__center'>
                        <p className='app__foodMenu-menu_heading'>Specials Menu</p>
                        <p className='app__foodMenu-menu_heading_fine-line' />
                        <p className='app__foodMenu-menu_heading'>Featured Specials</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.specials.map((special, index) => (
                                <MenuItem key={special.title + index} title={special.title} price={special.price} tags={special.tags} />
                            ))}
                        </div>
                        <p className='app__foodMenu-menu_heading'>Warning</p>
                        <div className='app__foodMenu-menu_items'>
                            {data.warnings.map((warning, index) => (
                                <MenuItem key={warning.title + index} title={warning.title} price={warning.price} tags={warning.tags} />
                            ))}
                        </div>
                    </div>
                )}
            </div >
        </div >

    )
};

export default FoodMenu;
